<template src="./AppointmentScheduled.html"></template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.18.1/moment.min.js"></script>
<script>
import mixins from "../../../../../Mixins.js";
import moment from "moment";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      appointmentScheduled: [],
      search: "",
      doctors: [],
      doctor: null,
      isProject: false,
      popupCancelAppointment: false,
      idAppointmentScheduled: null,
      idAppointment: "",
      medicalRecordId: "",
      popupInit: false,
      popupCancel: false,
      popupAbsent: false,
      cancellationTime: null,
      cancellationStatus:null
    };
  },
  mounted: function() {
    const vm = this;
    vm.init();
    vm.getIsProject();
  },
  watch: {
    doctor: function() {
      const vm = this;
      vm.getAppointmentSchedule(vm.doctor);
    }
  },
  methods: {
    init() {
      const vm = this;
      vm.getCancellationTime();
      vm.getDoctors();
    },
    getIsProject() {
      let vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "webclinics/check-is-project", {
          headers: {
            Authorization: vm.$session.get("bearer")
          }
        })
        .then(function(response) {
          vm.isProject = response.data;
        });
    },
    getCancellationTime() {
      const vm = this;
      this.axios
        .get(vm.$store.state.filooServer + "parameters/cancellation-time", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
           vm.cancellationTime = response.data;
           vm.getAppointmentSchedule();
        });
    },
    clickButtonCancelAppointment(id) {
      const vm = this;
      vm.popupCancelAppointment = true;
      vm.idAppointmentScheduled = id;
    },
    medicalConsult(medRecordId){
      const vm = this;
      vm.$router.push({path:"/patient-data/" + medRecordId, params: {id: medRecordId}});
    },
    getAppointmentSchedule(doctor) {
      const vm = this;
      let url =
        "webclinics/appointments?status=CONFIRMED&page=0&size=20&sort=id,desc";
      let options = {
        page: 0,
        size: 10,
        sort: ["id", "desc"]
      };
      var formatDateHourToBR = moment().add(parseInt(vm.cancellationTime),"month").format("DD/MM/YYYY HH:mm");
      vm.axios
        .get(vm.$store.state.filooServer + url, {
          headers: { Authorization: vm.$session.get("bearer") },
          options
        })
        .then(function(response) {
          vm.appointmentScheduled = response.data.content;
          for (let appointment in vm.appointmentScheduled) {
            vm.appointmentScheduled[appointment].price = vm.maskMoney(
              vm.appointmentScheduled[appointment].price
            );
            if(vm.appointmentScheduled[appointment].dateHour > formatDateHourToBR &&  vm.appointmentScheduled[appointment].taxPaid !== true){
              vm.appointmentScheduled[appointment].cancellationStatus = true;
            } else {
              vm.appointmentScheduled[appointment].cancellationStatus = false;
            }
          }

          if (vm.testNullUndefinedEmpty(doctor)) {
            for (let appointment in vm.appointmentScheduled) {
              if (!vm.testNullUndefinedEmpty(doctor) && vm.appointmentScheduled[appointment].doctor.name === doctor) {
                vm.appointmentScheduled[appointment] =
                  vm.appointmentScheduled[appointment];
              }
            }
          }
        });
    },
    getDoctors() {
      const vm = this;
      this.axios
        .get(vm.$store.state.filooServer + "clinic-doctors/doctors", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.doctors = response.data.content;
            let distinctDoctors = [
              ...new Set(vm.doctors.map(x => x.doctor.name))
            ];
            vm.doctors = distinctDoctors;
          }
        });
    },
    cancelAppointment() {
      const vm = this;
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "webclinics/appointments/" +
            vm.idAppointmentScheduled.id +
            "/cancel",
          {},
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.$swal({
              title: "Sucesso!",
              text: "Consulta cancelada",
              icon: "success"
            });
            vm.getAppointmentSchedule();
          } else {
            vm.$swal({
              title: "Erro",
              text: "Consulta não cancelada",
              icon: "warning"
            });
          }
          vm.popupCancelAppointment = false;
        })
        .catch(function() {
          vm.$swal({
            title: "Erro",
            text: "Consulta não cancelada",
            icon: "warning"
          });
          vm.popupCancelAppointment = false;
        });
    },
    initMedicalConsultation(medicalRecordId, appointmentId) {
      const vm = this;
      vm.medicalRecordId = medicalRecordId;
      vm.appointmentId = appointmentId;
      vm.popupInit = true;
    },
    cancelMedicalConsultation(appointmentId) {
      const vm = this;
      vm.idAppointment = appointmentId;
      vm.popupCancel = true;
    },
    absentPatient(appointmentId) {
      const vm = this;
      vm.idAppointment = appointmentId;
      vm.popupAbsent = true;
    },
    clickBtnInitConfirm() {
      const vm = this;
      vm.medicalConsult(vm.medicalRecordId);
      vm.popupInit = false;
    },
    clickBtnCancelConfirm() {
      const vm = this;
      var appointment = {};
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "doctor/appointments/" +
            vm.idAppointment +
            "/cancel",
          appointment,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          vm.popupCancel = false;
          if (response.status === 200) {
            vm.getAppointmentSchedule();
            vm.$swal("Sucesso!", "Consulta cancelada", "success");
          } else {
            vm.$swal("Erro ao cancelar", "error");
          }
        })
        .catch(function() {
          vm.$swal("Erro ao cancelar", "error");
        });
    },

    clickBtnAbsentConfirm() {
      const vm = this;
      var appointment = {};
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "webclinics/appointments/" +
            vm.idAppointment +
            "/noshow",
          appointment,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          vm.popupAbsent = false;
          if (response.status === 200) {
            vm.getAppointmentSchedule();
            vm.$swal("Sucesso!", "Consulta cancelada", "success");
          } else {
            vm.$swal("Erro ao cancelar", "error");
          }
        })
        .catch(function() {
          vm.$swal("Erro ao cancelar", "error");
        });
    }
  }
};
</script>
<style lang="scss" src="./AppointmentScheduled.scss">
</style>
